// extracted by mini-css-extract-plugin
export var dropdownIcon = "_rc-6";
export var imgContainer = "_rc-3";
export var menuIcon = "_rc-5";
export var pillWrapper = "_rc-2";
export var pillsContainer = "_rc-1";
export var subscriptionCard = "_rc-0";
export var subscriptionLogo = "_rc-4";